// extracted by mini-css-extract-plugin
export default {"icon":"MenuItem_icon__iNTZO","menuItem":"MenuItem_menuItem__O4tTb","active":"MenuItem_active__c5PQ6"};